import { IPartialChildNode, IPartialChildNodeWithIndex } from './interfaces/patternsHtmlTags.interface';

export class HtmlNodesHelper {
  static getLinesFrom(nodeArray: IPartialChildNodeWithIndex []): [number, number] {
    if (nodeArray.length === 0) return [-1, -1];
    return [nodeArray[0].index, nodeArray[nodeArray.length - 1].index];
  }

  static removeEmpty(nodes: IPartialChildNodeWithIndex[]): IPartialChildNodeWithIndex[] {
    return nodes.filter(node => node.textContent?.trim());
  }

  static convertToPartialWithIndex(htmlNodes: NodeListOf<ChildNode>): IPartialChildNodeWithIndex[] {
    if (!htmlNodes) return [];

    return (Array.from(htmlNodes)).map((node, index) => {
      return {
        ...this.getHtmlNodeProperties(node),
        index,
      };
    });
  }

  static getHtmlNodeProperties(htmlNode: ChildNode): IPartialChildNode {
    return {
      childNodes: htmlNode.childNodes,
      textContent: htmlNode.textContent,
      nodeName: htmlNode.nodeName,
    };
  }

  static countTags(htmlNodes: NodeListOf<ChildNode>, tag: string): number {
    if (!htmlNodes) return 0;

    return Array.from(htmlNodes).reduce<number>((total, htmlNode) => {
      if (htmlNode.nodeName === tag) return total + 1;
      return total;
    }, 0);
  }
}
